import React, {useEffect, useState, useContext} from "react";
import {Context as AuthContext} from '../../context/AuthContext'
import {Context as MenuContext} from '../../context/MenuContext'
import BuyButton from '../../components/stripe/BuyButton'

export default function StripeDashboard() {
  const authContext = useContext(AuthContext);
  const menuContext = useContext(MenuContext);
  const {id, email, plan_name, stripe_id} = authContext.state;

  useEffect(() => {
    menuContext.setMainPageLeftMenu({title: 'Plans', subtitle: "JustCast", currentPageId: 'home'});
  }, []);


  return (
    <div className="container-fluid">
      {
        plan_name && <div className="row justify-content-between align-items-center mb-5">
          <div className="col-12 col-md-9 col-xl-7">
            <h2 className="mb-2">
              {plan_name}
            </h2>
            <p className="text-muted mb-md-0">
              {`You're currently subscribed to the ${plan_name}.`}
            </p>
          </div>
        </div>
      }
      <div className="text-center">
        <BuyButton
          email={email}
          userId={id}
          planName={plan_name}
          customerId={stripe_id}
          buyButtonId={process.env.REACT_APP_STRIPE_LIFETIME_BUY_BUTTON_ID}
        />
      </div>
    </div>
  )
}
